
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.524 22.672L19.899 12.047a1.867 1.867 0 00-2.649 0l-1.765 1.765a1.867 1.867 0 000 2.649L23.008 24l-7.531 7.531a1.867 1.867 0 000 2.649l1.766 1.773a1.867 1.867 0 002.648 0l10.625-10.625a1.87 1.87 0 00.008-2.656z","fill":"#535353"}})])
          )
        }
      }
    